import { Link } from "react-router-dom";
import { EnvelopeSimple, FileText, AddressBook, Database, CaretLeft, ChartLineUp, Lightning } from "@phosphor-icons/react";

const TILES = [
  { key: "template", label: "Template", icon: FileText, color: "text-amber-400", border: "hover:border-amber-400/50", to: "/marketing/email/template",
    desc: "Componi le newsletter: creazione, bozze, invio, programmazione e storico" },
  { key: "liste", label: "Liste", icon: AddressBook, color: "text-violet-400", border: "hover:border-violet-400/50", to: "/marketing/email/liste",
    desc: "Liste di contatti centralizzate: crea, gestisci e usale come destinatari" },
  { key: "automazioni", label: "Automazioni", icon: Lightning, color: "text-amber-400", border: "hover:border-amber-400/50", to: "/marketing/email/automazioni",
    desc: "Sequenze automatiche: benvenuto e promemoria per i nuovi contatti delle liste" },
  { key: "statistiche", label: "Statistiche", icon: ChartLineUp, color: "text-emerald-400", border: "hover:border-emerald-400/50", to: "/marketing/email/statistiche",
    desc: "Aperture e clic delle newsletter inviate: scopri cosa funziona meglio" },
  { key: "database", label: "Database", icon: Database, color: "text-sky-400", border: "hover:border-sky-400/50", to: "/marketing/email/database",
    desc: "Importa i contatti dai database delle WebApp collegate" },
];

export default function MarketingEmailPage() {
  return (
    <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8 sm:py-12" data-testid="marketing-email-page">
      <div className="mb-10 animate-fade-up">
        <Link to="/marketing" data-testid="back-to-marketing" className="inline-flex items-center gap-1 text-xs font-semibold text-white/50 hover:text-white transition-colors mb-4">
          <CaretLeft size={13} /> Marketing
        </Link>
        <p className="text-xs tracking-[0.3em] uppercase text-white/40 mb-2 flex items-center gap-1.5">
          <EnvelopeSimple size={13} className="text-amber-400" /> Canale Email
        </p>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tighter leading-none">Email</h1>
        <p className="text-sm text-slate-400 mt-3 max-w-2xl">Gestisci newsletter e liste di contatti per il canale email.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
        {TILES.map((t, i) => {
          const Icon = t.icon;
          return (
            <Link key={t.key} to={t.to} data-testid={`email-tile-${t.key}`}
              className={`group text-left p-8 rounded-lg bg-surface border border-surface-border ${t.border} transition-colors duration-200 animate-fade-up`}
              style={{ animationDelay: `${80 + i * 80}ms` }}>
              <Icon size={44} weight="duotone" className={`${t.color} mb-5 transition-transform duration-200 group-hover:scale-110`} />
              <h2 className="font-heading text-2xl font-semibold tracking-tight mb-1">{t.label}</h2>
              <p className="text-sm text-slate-400 mb-4">{t.desc}</p>
              <span className="text-xs font-semibold text-white/50 group-hover:text-white transition-colors">Apri →</span>
            </Link>
          );
        })}
      </div>
    </main>
  );
}
